<template>
    <div>

        <BuyerStatusDrawer
            v-model="statusDrawer"
            :buyers="statusDrawerBuyers"
            :statusId="statusDrawerStatusId"
            :statusList="buyer_status_list"
            :listingId="statusDrawerListing.lid"
            :listingIdentifier="statusDrawerListing.listing_id"
            @input="open => { if (!open) statusSelectKey++ }"
            @updated="statusUpdated"
            @failed="message => triggerUserFeedback( true, message, 'accent' )" />

        <!-- <v-dialog 
            v-model="disableDialog" 
            width="40%"
            elevation="8"
            persistent>
                <DisableProject 
                    :disableArgs="disableArgs"
                    :project_statuses="project_statuses"
                    @closeProject="closeProject"
                    @refreshProject="refreshProject"
                    @closeDisableDialog="closeDisableDialog"
                    @triggerUserFeedback="triggerUserFeedback" />
        </v-dialog>  -->

        <v-dialog 
            v-model="profileDialog" 
            transition="dialog-bottom-transition"
            max-width="83%"
            scrollable>
            <v-card>
                <v-card-title class="info d-flex justify-space-between align-center">
                    <div v-if="readyToLoad" class="pewter--text font-weight-bold">
                        <UserData_Dashboard 
                            :key="project_id"
                            :user_data="project_details.users"
                            source="buyer"
                        />
                    </div>
                    <div class="justify-end">
                        <v-btn 
                            icon 
                            dark 
                            class="ml-3"
                            @click="profileDialog = false">
                            <v-icon color="pewter">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <ModuleQuestionnaire 
                        v-if="readyToLoad"
                        :key="current_milliseconds"
                        :user_id="user_data[0].user_id"
                        :module_key="moduleKey"
                        :module_id="moduleId"
                        :project_id="projectId"
                        :isOpen="profileDialog"
                        :openQuestionnaire="openQuestionnaire"
                        @questionnaireProgressUpdated="applyQuestionnaireProgressUpdate"
                    />
                </v-card-text>
                <v-card-actions class="info">
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                        outlined
                        color="pewter"
                        class="mr-3"
                        @click="buyerQuestionnaire_dialog = false">
                        close
                    </v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog 
            v-model="videoDialog" 
            persistent
            width="55%"
            elevation="8">
            <v-card>
                <v-card-title class="headline primary darken-1 white--text d-flex justify-space-between">
                    {{ videoTitle }}
                    <v-btn
                        icon
                        @click="closeVideo()">
                        <v-icon 
                            class="white--text">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="py-6 align-center mx-auto">                    
                    <div v-if="videoValid === null || videoValid === false">
                        <v-progress-circular   
                            v-if="videoValid === null"
                            indeterminate
                            color="primary"
                            class="mx-auto my-12 py-12 d-block"
                            size="100"
                            width="5">
                        </v-progress-circular>

                        <div v-if="videoValid === false" class="d-block my-12 py-12 text-center sansation_title">
                            We're sorry, this video is not available at this time.
                        </div>
                    </div>

                    <VideoPlayer v-if="videoValid"
                        :key="videoUrl"
                        :video_id="videoUrl"
                        :video_src="videoSrc"
                        :video_type="videoType" />
                </v-card-text>
            </v-card>
        </v-dialog>

        <div  v-if="readyToLoad" class="d-flex py-5 px-6 header_bg_color align-center justify-space-between">
            <div class="pewter--text font-weight-bold justify-start">
                <UserData_Dashboard 
                    :key="project_id"
                    :user_data="project_details.users"
                    source="buyer"
                />
            </div>

            <div class="justify-end">
                <v-btn 
                    icon
                    outlined
                    color="white"
                    elevation="1"
                    @click="closeProject()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </div>

        <div v-if="!readyToLoad" class="text-center py-12 my-12" style="width: 100%">
            <v-progress-circular
                indeterminate 
                color="error darken-3" 
                class="my-12 py-12" 
                size="100" 
                width="8">
            </v-progress-circular>
        </div>
        
        <div v-else>
            <div class="px-5 pt-5 d-flex d-block align-top justify-space-between">
                <div class="align-top">
                    <div class="d-flex align-center">
                        <customIcon v-if="project_details.modinfo.module_key && project_details.modinfo.module_key != ''" :name="project_details.modinfo.module_key" class="d-inline ml-n2 mr-1 info--text text--lighten-2 icon-size-header" />
                        <div class="d-inline info--text text--lighten-2 label_large" v-html="project_details.modinfo.module_name"></div>
                    </div>
                </div>
                    
                <div class="justify-space-between pt-2">
                    <div class="d-block text-right">
                        <v-btn
                            v-if="project_details.has_data || project_details.date_submitted"
                            small
                            outlined
                            color="primary"
                            class="mr-3 justify-end"
                            @click.stop.prevent="exportAnswers(project_details)">
                            Export Answers
                        </v-btn>
                        <v-btn
                            small
                            elevation=0
                            color="primary"
                            class="justify-end"
                            @click.stop.prevent="openQuestionnaire(project_details)">
                            View Questionnaire
                        </v-btn>
                    </div>
                    <div class="d-block text-right" v-if="project_details.questionnaire_progress">
                        <v-progress-linear
                            :value="questionnaire_percentage == 0 ? 1 : questionnaire_percentage"
                            color="accent darken-1"
                            class="pa-0 mx-0 mt-3 mb-0 justify-end" 
                            rounded
                            width="100"
                            height="5">
                        </v-progress-linear>
                        <div class="caption font-weight-thin justify-end mb-3">
                            {{ questionnaire_completed_sections+' of '+questionnaire_total_sections }} sections ({{ questionnaire_percentage }}%) complete
                        </div>
                    </div>
                </div>
            </div>

            <v-card-text class="my-0 py-0">
                <v-card outlined class="mt-1 mb-2 py-1 px-5 d-flex d-block align-center sansation menu_bg_primary">
                    
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'overview'" class="primary--text text--darken-1" @click="projectView('overview')">Overview</a>
                        <div v-if="project_detail_view == 'overview'" class="grey--text">Overview</div>
                    </div>

                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'activity'" class="primary--text text--darken-1" @click="projectView('activity')">Activity</a>
                        <div v-if="project_detail_view == 'activity'" class="grey--text">Activity</div>
                    </div>

                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'docs'" class="primary--text text--darken-1" @click="projectView('docs')">Documents</a>
                        <div v-if="project_detail_view == 'docs'" class="grey--text">Documents</div>
                    </div>

                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'users'" class="primary--text text--darken-1" @click="projectView('users')">Users</a>
                        <div v-if="project_detail_view == 'users'" class="grey--text">Users</div>
                    </div>

                    <v-spacer></v-spacer>
                    <div class="d-inline caption grey--text"
                        @click="handleCopyProjectId( project_details.project_id )">

                        <v-tooltip bottom content-class="contact_tooltip cursor-pointer">
                            <template v-slot:activator="{ on, attrs }">
                                <span 
                                    :id="`copy-pid-${project_details.project_id}`"
                                    class="font-weight-thin primary--text text--darken-1"
                                    v-bind="attrs"
                                    v-on="on">
                                    <v-icon 
                                        x-small 
                                        class="mr-1"
                                        color="primary darken-1">
                                        mdi-content-copy
                                    </v-icon>
                                    {{ project_details.project_id }}
                                </span>
                            </template>
                            <span>{{ trigger_copied ? 'copied' : 'click to copy' }}</span>
                        </v-tooltip>
                    </div>

                </v-card>

                <v-card v-if="project_detail_view == 'overview'" elevation="0" class="mt-6 pb-12">
                    <div class="d-flex d-block justify-space-between pb-9">
                        <div class="d-inline align-center" style="width: 40%">
                            <div class="mt-1 d-block">
                                <div class="label_medium info--text d-inline">Start Date:</div>
                                <div class="primary--text text--darken-1 d-inline ml-2">{{ formatThisDate(project_details.date_initialized) }}</div> 
                            </div>
                            
                            <div class="mt-3 d-block">
                                <div class="d-inline label_medium info--text mr-4 text-no-wrap">Add buyer to available listings:</div>
                                <div class="d-flex d-inline align-center">
                                    <v-select
                                        v-model="available_buyer_listings"
                                        :items="available_listings" 
                                        label="Select listings"
                                        class="d-inline"
                                        hide-details
                                        multiple>
                                        <template v-slot:item="{ item, attrs, on }">
                                            <v-list-item v-bind="attrs" v-on="on" #default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :input-value="active" color="primary" hide-details></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        {{ [item.practice_type_text, item.status_text, item.accepting_text].filter(Boolean).join('  ::  ') }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                    <v-btn 
                                        class="mt-4 ml-4 d-inline"
                                        color="primary lighten-1" 
                                        small
                                        :disabled="!available_buyer_listings.length"
                                        @click="expressInterest(project_details.user_id)">
                                        Apply
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        
                        <div class="d-inline justify-end" style="width:40%">
                            <div class="d-block pb-1 label_medium info--text">
                                {{ project_details.status == 'completed' ? 'Profile Considered Complete' : 'Profile Not Complete' }}
                            </div>
                            <v-progress-linear
                                :active="true"
                                buffer-value="100"
                                height="12"
                                rounded
                                striped
                                :value="project_details.profile_percentage"
                                color="success darken-1">
                            </v-progress-linear>
                            <div class="d-block caption info--text text--lighten-3">
                                <div v-if="project_details.questionnaire_progress">{{ project_details.profile_percentage }}% ({{ project_details.questionnaire_progress.finished }} of {{ project_details.questionnaire_progress.total }}) sections 100% completed</div>
                                <div v-else>sectional progress not calculated yet</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="my-12">
                        <!-- Current / Archived toggle (same as the client's expressed-interest view) -->
                        <div class="d-flex justify-space-between align-center mt-6 mb-3">
                            <div class="label_medium info--text">Buyer has expressed interest in these listings:</div>
                            <div class="d-flex align-center sansation">
                                <a v-if="interest_type != 'current'" class="px-4 primary--text" @click="interest_type = 'current'">Current Interest ({{ currentInterestListings.length }})</a>
                                <div v-else class="px-4">Current Interest ({{ currentInterestListings.length }})</div>
                                <v-divider vertical></v-divider>
                                <a v-if="interest_type != 'archived'" class="px-4 primary--text" @click="interest_type = 'archived'">Archived Interest ({{ archivedInterestListings.length }})</a>
                                <div v-else class="px-4">Archived Interest ({{ archivedInterestListings.length }})</div>
                            </div>
                        </div>

                        <div v-if="listings_refresh" class="d-flex justify-center">
                            <v-progress-circular
                                indeterminate 
                                color="error darken-3" 
                                class="ma-12" 
                                size="60" 
                                width="4">
                            </v-progress-circular>
                        </div>

                        <template v-else>
                            <div v-if="!visibleInterestListings.length" class="grey--text text--darken-1 py-6">
                                {{ interest_type == 'archived' ? 'No archived interest.' : 'No current interest.' }}
                            </div>

                            <v-hover
                                v-for="listing in visibleInterestListings"
                                :key="listing.id"
                                v-slot="{ hover }">
                                <v-card class="mb-6" :class="hover ? 'elevation-6' : ''">
                                    <!-- The whole bar toggles the card, except the listing ID link on the far left -->
                                    <v-card-title 
                                        class="py-3 px-4 d-flex justify-space-between align-center grey lighten-4 listing-card-toggle" 
                                        :class="(listing.is_archived || listing.is_disqualified) ? 'grey--text' : 'primary--text'"
                                        @click="toggleListingCard(listing.id)"
                                    >
                                        <div class="d-inline sansation">
                                            <span class="listing-id-link" @click.stop="openBuyersDialog($event, listing)">
                                                <a class="buyers_link">{{ listing.listing_id }}</a>
                                                <v-icon x-small class="mt-n1 ml-1" color="primary">mdi-open-in-new</v-icon>
                                            </span>
                                            <div v-if="listing.practice_type" class="d-inline ml-4 mr-1 grey--text">{{ listing.practice_type.text }}</div>
                                            <div class="d-inline mx-1 grey--text">::</div>
                                            <div class="d-inline mx-1 grey--text">{{ listing.accepting_flag ? 'Accepting Applications' : 'Not Accepting Applications' }}</div>
                                            <template v-if="listing.status_text">
                                                <div class="d-inline mx-1 grey--text">::</div>
                                                <div class="d-inline mx-1 status_pause--text">{{ listing.status_text }}</div>
                                            </template>
                                        </div>

                                        <div class="d-flex align-center grey--text text--darken-1 sansation">
                                            <!-- Collapsed summary: current status & whether there are notes -->
                                            <template v-if="!expandedListings[listing.id]">
                                                <v-tooltip v-if="hasNotes(listing.notes)" bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <span class="notes-dot mr-8" v-bind="attrs" v-on="on"></span>
                                                    </template>
                                                    <span>Has notes</span>
                                                </v-tooltip>

                                                <template v-if="hasAdjustedScore(listing)">
                                                    <div class="mr-3">Compatibility Score:</div>
                                                    <div class="grey--text text--lighten-1">{{ compatibilityScoreText(listing) }}</div>
                                                    <v-divider vertical class="mx-3"></v-divider>
                                                </template>
                                            </template>

                                            <div class="mr-3">{{ listing.status_change_date ? 'Status Changed:' : 'Expressed Interest:' }}</div>
                                            <div class="grey--text text--lighten-1">{{ formatThisDate(listing.status_change_date || listing.created_date, listingDateFormat) }}</div>

                                            <template v-if="!expandedListings[listing.id]">
                                                <v-divider vertical class="mx-3"></v-divider>
                                                <div class="caption text-uppercase">{{ listingStatusText(listing) }}</div>
                                            </template>
                                        </div>
                                    </v-card-title>

                                    <v-expand-transition>
                                        <div v-show="expandedListings[listing.id]">
                                            <v-divider class="mb-2"></v-divider>

                                            <v-card-text class="sansation">
                                                <div class="d-flex justify-space-between">
                                                    <div class="d-flex flex-column justify-space-between">
                                                        <div class="d-flex align-center">
                                                            <div>Status:</div>
                                                            <v-chip
                                                                color="light_primary" 
                                                                class="ml-2 text-uppercase grey--text text--darken-2">
                                                                {{ listingStatusText(listing) }}
                                                                <v-tooltip
                                                                    v-if="listing.status_reason && listing.status_reason.explaination"
                                                                    bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon 
                                                                            v-on="on"
                                                                            color="grey darken-1"
                                                                            class="ml-2">
                                                                            mdi-information
                                                                        </v-icon>
                                                                    </template>
                                                                    <div style="width: 300px" class="px-1 py-2" v-html="listing.status_reason.explaination"></div>
                                                                </v-tooltip>
                                                            </v-chip>

                                                            <v-select 
                                                                :key="`status-${listing.id}-${statusSelectKey}`"
                                                                :value="listing.selected_buyer_status[0]"
                                                                :items="buyer_status_list"
                                                                item-value="value" 
                                                                item-text="text"
                                                                label="Change Status"
                                                                dense
                                                                outlined
                                                                hide-details
                                                                class="ml-8"
                                                                @change="status => openStatusDrawer(listing, status)">
                                                            </v-select>
                                                        </div>

                                                        <div class="my-8">
                                                            Compatibility Score:
                                                            <span class="grey--text text--lighten-1 ml-2">{{ compatibilityScoreText(listing) }}</span>
                                                        </div>

                                                        <div>
                                                            <v-btn
                                                                color="primary lighten-1"
                                                                class="elevation-0"
                                                                @click="archiveInterest(listing, !listing.is_archived ? true : false)">
                                                                {{ !listing.is_archived ? 'Archive Interest' : 'Unarchive Interest' }}
                                                            </v-btn>
                                                        </div>
                                                    </div>

                                                    <div class="d-inline">
                                                        <div class="d-block text-right">
                                                            <div class="d-inline">Listing Stage:</div>
                                                            <div class="d-inline grey--text text--lighten-1 ml-2">{{ listing.listing_stage ? listing.listing_stage.text : 'N/A' }}</div>
                                                        </div>
                                                        <div class="d-block my-3 text-right">
                                                            <div class="d-inline">Asking Price:</div>
                                                            <div class="d-inline grey--text text--lighten-1 ml-2">{{ listing.asking_price_text }}</div>
                                                        </div>
                                                        <div class="d-block my-3 text-right">
                                                            <div class="d-inline">AUM:</div>
                                                            <div class="d-inline grey--text text--lighten-1 ml-2">{{ formatListingMoney(listing.aum) }}</div>
                                                        </div>
                                                        <div class="d-block mt-3 text-right">
                                                            <div class="d-inline">Revenue:</div>
                                                            <div class="d-inline grey--text text--lighten-1 ml-2">{{ formatListingMoney(listing.revenue) }}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- <v-divider class="my-4"></v-divider> -->

                                                <div class="d-block mt-8">
                                                    <div class="d-block info--text mb-1">Notes:</div>
                                                    <WysiwygEditor
                                                        :key="`notes-${listing.id}`"
                                                        :value="listing.notes || ''"
                                                        @input="val => $set(listing, 'notes', val)"
                                                        style="width: 100%;"
                                                        :toolbar="quickNotesToolbar">
                                                    </WysiwygEditor>
                                                    <div class="d-flex d-block justify-end mt-2">
                                                        <v-btn 
                                                            color="primary lighten-1" 
                                                            class="ml-1 mb-1 elevation-0"
                                                            small
                                                            @click="saveNotes(noteArgs = {buyer: listing, user_data})">
                                                            save notes
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                        </div>
                                    </v-expand-transition>
                                </v-card>
                            </v-hover>
                        </template>
                    </div>
                </v-card>

                <v-card v-if="project_detail_view == 'activity'" elevation="0" class="mt-6 pb-12">
                     <ActivityLogs
                        :projectID="project_details.project_id"
                        :userID="project_details.user_id" />
                </v-card>

                <!-- <v-card v-if="project_detail_view == 'report' && project_details.show_psr" elevation="0" class="mt-6 pb-12">
                    <ProjectReport
                        :projectDetails="project_details"
                    />
                </v-card> -->

                <v-card v-if="project_detail_view == 'docs'" elevation="0" class="mt-6 pb-12">
                    <ProjectFiles
                        :projectDetails="project_details"
                        :refresh_docs="refresh_docs"
                        :triggerUserFeedback="triggerUserFeedback"
                        :formatThisDate="formatThisDate"
                        @pullProjectDocs="pullProjectDocs" />
                    
                    <div class="my-10">&nbsp;</div>
                    
                    <ProjectDeliverables
                        :projectDeliverables="project_details"
                        :refresh_delivs="refresh_delivs"
                        :triggerUserFeedback="triggerUserFeedback"
                        :formatThisDate="formatThisDate"
                        @pullProjectDelivs="pullProjectDelivs" />

                    <div class="my-10">&nbsp;</div>

                    <ProjectResources
                        :projectResources="project_details"
                        @toggleVisiblity="toggleVisiblity"
                        @playResourceVideo="playResourceVideo" />
                </v-card>

                <v-card v-if="project_detail_view == 'users'" elevation="0" class="mt-6 pb-12">
                    <ProjectUsers
                        :projectDetails="project_details"
                        :formatThisDate="formatThisDate"
                        @refreshUsers="refreshUsers" />
                </v-card>
            </v-card-text>

            <v-card-actions class="pa-4 d-flex justify-end" style="border-top: 1px solid #BDBDBD">
                <v-btn 
                    class="d-inline menu_bg_primary primary--text text--darken-1"
                    elevation=0
                    :loading="refreshing_project"
                    @click="refreshProject(project_details)">
                    <v-icon color="primary">mdi-refresh</v-icon>
                </v-btn>
            </v-card-actions>
        </div>
    </div>
</template>


<script>  
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'
    import { dataTimeDisplayFormatter } from './utilities'
    import { formatBigInt } from '../helpers/utilities'

    import ProjectData from './ProjectData'
    import ProjectFiles from './ProjectFiles'
    import ProjectDeliverables from './ProjectDeliverables'
    import ProjectResources from './ProjectResources'
    import UserData_Dashboard from './UserData_Dashboard.vue'
    import ModuleQuestionnaire from './ModuleQuestionnaire'
    import ActivityLogs from './ActivityLogs'
    import ProjectUsers from './ProjectUsers'
    import VideoPlayer from './video'
    import BuyerStatusDrawer from './shared/BuyerStatusDrawer.vue'
    import WysiwygEditor from './WysiwygEditor.vue'
    import { quickNotesToolbar } from './shared/editorToolbars'
    // import ProjectReport from './ProjectReport'
    // import DisableProject from './dialogs/DisableProject.vue'

    export default {
        name: 'ProjectDetails',

        components: {
            ProjectData,
            ProjectFiles,
            ProjectDeliverables,
            ProjectResources,
            UserData_Dashboard,
            ModuleQuestionnaire,
            ActivityLogs,
            ProjectUsers,
            VideoPlayer,
            BuyerStatusDrawer,
            WysiwygEditor
            // ProjectReport,
            // DisableProject

        },

        props: {
            user_id: String,
            project_id: String,
            project_statuses: Array,
            openTab: String,
            closeBuyerDialog: Function,
            currentInterestListings: { type: Array, default: () => [] },
            archivedInterestListings: { type: Array, default: () => [] },
            available_listings: { type: Array, default: () => [] }
        },

        computed: {
            questionnaire_completed_sections () {
                if (Array.isArray(this.project_details.questionnaire_sections) && this.project_details.questionnaire_sections.length > 0) {
                    return this.project_details.questionnaire_sections.filter(s => s.is_complete).length
                }

                const questionnaireProgress = this.project_details && this.project_details.questionnaire_progress
                    ? this.project_details.questionnaire_progress
                    : {}
                const finished = Number.parseInt(questionnaireProgress.finished, 10)
                return Number.isFinite(finished) && finished > 0 ? finished : 0
            },

            questionnaire_total_sections () {
                if (Array.isArray(this.project_details.questionnaire_sections) && this.project_details.questionnaire_sections.length > 0) {
                    return this.project_details.questionnaire_sections.length
                }

                const questionnaireProgress = this.project_details && this.project_details.questionnaire_progress
                    ? this.project_details.questionnaire_progress
                    : {}
                const finished = Number.parseInt(questionnaireProgress.finished, 10)
                const total = Number.parseInt(questionnaireProgress.total, 10)
                const normalizedFinished = Number.isFinite(finished) && finished > 0 ? finished : 0
                const normalizedTotal = Number.isFinite(total) && total > 0 ? total : 0
                return Math.max(normalizedTotal, normalizedFinished)
            },

            visibleInterestListings () {
                return this.interest_type == 'archived' ? this.archivedInterestListings : this.currentInterestListings
            },

            questionnaire_percentage () {
                const total = this.questionnaire_total_sections
                if (total <= 0) return 0

                return Math.ceil((this.questionnaire_completed_sections / total) * 100)
            }
        },

        data () {
            return {
                listings_refresh: false,
                project_detail_view: this.openTab || 'overview',
                trigger_copied: false,
                project_details: {},
                user_data: {},
                date_menu: false,
                disableDialog: false,
                profileDialog: false,
                deliverableDialog: false,
                titleDialog: false,
                videoDialog: null,
                videoUrl: '',
                videoSrc: '',
                videoType: '',
                videoTitle: 'Resource Video',
                videoValid: null,
                dateMenu: false,
                archive_action: '',
                remove_project_id: '',
                remove_module_name: '',
                refresh_docs: false,
                refresh_delivs: false,
                refreshing_project: false,
                triggerFeedback: false,
                trigger_copied: false,
                noteArgs: {},
                available_buyer_listings: [],
                expressData: {},
                holdArgs: {},
                stepArgs: {},
                disableArgs: {},
                disable_action: '',
                buyerProject: [],
                moduleKey: '',
                moduleId: '',
                projectId: '',
                show_this: '',
                projectDeliverables: [],
                max100chars: [v => v.length <= 100 || 'Max 100 characters'],
                updateProject: {},
                showCompletedDate: false,
                readyToLoad: false,
                archiveWork: false,
                current_milliseconds: new Date().getTime(),
                buyer_status_list: [],
                statusDrawer: false,
                statusDrawerBuyers: [],
                statusDrawerStatusId: null,
                statusDrawerListing: {},
                statusSelectKey: 0,
                // listing card id -> true when expanded (cards start collapsed)
                expandedListings: {},
                // which of the buyer's interests to show, split on is_archived (like the client view)
                interest_type: 'current',
                listingDateFormat: { month: 'short', day: '2-digit', year: 'numeric' },
                quickNotesToolbar,
            }
        },

        watch: {            
            openTab: {
                handler (val) {
                    this.projectView(val || 'overview')
                }
            },
            project_id: {
                handler(val){
                    if (val) {
                        this.projectDetails(this.user_id, this.project_id);
                    }
                }
            },
            project_detail_view: {
                handler (val) {
                    this.projectView(val)
                }
            }
        },

        created () {
            // console.log(this.user_id, this.project_id)
            this.projectDetails(this.user_id, this.project_id);
        },

        mounted () {
            this.projectView(this.openTab || 'overview')
        },
        
        methods: {
            formatThisDate: function ( date, options, iso_format=false ) {
                if (!date) return false;

                const defaultOptions = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }
                return dataTimeDisplayFormatter(date, options ? options : defaultOptions, iso_format )
            },

            closeProject: function ( val ) {
                this.readyToLoad = false
                this.projectView('overview')
                this.$emit('closeBuyerDialog', val)
            },
            
            projectView: async function (view) {
                this.project_detail_view = view
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },
            
            handleCopyProjectId: function ( id ) {
                navigator.clipboard.writeText(document.querySelector(`span#copy-pid-${id}`).innerText.trim())
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 3000);
            },

            openQuestionnaire: function ( prj ) {
                this.moduleKey = prj.modinfo.module_key
                this.projectId = prj.project_id
                this.moduleId = prj.module_id

                setTimeout(()=>{ 
                    this.profileDialog = true 
                }, 1000)
            },

            openBuyersDialog: async function ( e, item ) {
                let route = this.$router.resolve({ path: `/listing_buyers/${item.lid}`});
                window.open(route.href, '_blank');
            },

            // listings are owned by ProjectOverview so it can show interest counts on the buyer card
            getListingsForBuyer: function (user_id) {
                this.$emit('refreshListings', user_id)
            },

            projectDetails: async function ( userId , projectId ) {
                try {
                    await this.getLists();
                    const current_project = await axios.get(`${appUrls.api}/api/admin/current_project/${userId}/${projectId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    
                    if ( current_project.data.outcome ) {
                        this.project_details = current_project.data.project_data
                        const projectUsers = Array.isArray(this.project_details.users) ? this.project_details.users : []
                        this.user_data = projectUsers.filter( usr => usr.user_type == 'owner' )
                        this.readyToLoad = true
                     } else {
                        this.$feedback.error( current_project.data.message );
                    }
                    // console.log(this.project_details)
                } catch ( error ) {
                    console.log(error);
                }
            },

            applyQuestionnaireProgressUpdate: function ( payload ) {
                if ( !payload || !this.project_details ) return

                const incomingProgress = payload.questionnaire_progress && typeof payload.questionnaire_progress === 'object'
                    ? payload.questionnaire_progress
                    : null

                if ( incomingProgress ) {
                    this.project_details.questionnaire_progress = {
                        ...(this.project_details.questionnaire_progress || {}),
                        ...incomingProgress
                    }
                }

                if ( Array.isArray(payload.questionnaire_sections) ) {
                    this.project_details.questionnaire_sections = payload.questionnaire_sections
                }

                if ( typeof payload.profile_percentage === 'number' ) {
                    this.project_details.profile_percentage = payload.profile_percentage
                }

                if ( typeof payload.status === 'string' && payload.status ) {
                    this.project_details.status = payload.status
                    this.showCompletedDate = payload.status === 'complete'
                }

                if ( payload.date_submitted !== undefined ) {
                    this.project_details.date_submitted = payload.date_submitted
                }
            },
            
            saveNotes: async function ( noteArgs ) {
                let buyerData = noteArgs.buyer
                let userData = noteArgs.user_data[0]
                buyerData.buyer_fullname = userData.first_name+' '+userData.last_name

                const saving_note_rs = await axios.post(`${appUrls.api}/api/admin/save_buyer_notes`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    buyer: buyerData
                })

                this.triggerUserFeedback( true, saving_note_rs.data.message )
            },

            getLists: async function () {
                try {
                    let optionsLists = [ 
                        {'name': 'buyer_status', 'type': 'txt'},
                    ];

                    const get_lists = await axios.post(`${appUrls.api}/api/lists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        list_options: optionsLists
                    })

                    if ( get_lists.data.outcome ) {
                        this.arrLists = get_lists.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in this.arrLists) {
                            if (this.arrLists[l].name == 'buyer_status') this.buyer_status_list = this.arrLists[l].list
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                };
            },

            refreshProject: async function ( prj ) {
                try {
                    this.refreshing_project = true;
                    const prj_rs = await axios.get(`${appUrls.api}/api/admin/current_project/${prj.user_id}/${prj.project_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })

                    setTimeout(() => {
                        this.project_details = prj_rs.data.project_data                        
                        const projectUsers = Array.isArray(this.project_details.users) ? this.project_details.users : []
                        this.user_data = projectUsers.filter( usr => usr.user_type == 'owner' )
                        this.refreshing_project = false;

                        if ( this.project_details.status == 'complete' ) {
                            this.showCompletedDate = true
                        } else {
                            this.showCompletedDate = false
                        }
                    }, 1000)

                    setTimeout(() => {
                        this.triggerUserFeedback( true, "Buyer data has been refreshed");
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            listingStatusText: function ( listing ) {
                // Same label the client sees on their card
                if ( listing.buyer_status ) return listing.buyer_status.description || listing.buyer_status.text

                const current = Array.isArray(listing.selected_buyer_status) ? listing.selected_buyer_status[0] : null
                if ( current && typeof current === 'object' && current.text ) return current.text

                const found = this.buyer_status_list.find( status => status.value == (current || listing.status_id) )
                return found ? found.text : 'No Status'
            },

            // Notes are HTML from the WysiwygEditor, so ignore empty tags/whitespace
            hasNotes: function ( notes ) {
                if ( !notes ) return false
                return String(notes).replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim().length > 0
            },

            hasAdjustedScore: function ( listing ) {
                const score = listing.adjusted_compatibility_score
                return score !== null && score !== undefined && String(score).trim() !== ''
            },

            // "score | adjusted score", with N/A for whichever is blank
            compatibilityScoreText: function ( listing ) {
                return [listing.compatibility_score, listing.adjusted_compatibility_score]
                    .map( score => score !== null && score !== undefined && String(score).trim() !== '' ? score : 'N/A' )
                    .join('  |  ')
            },

            formatListingMoney: function ( value ) {
                return value != null && value !== '' ? formatBigInt(value, false, true) : 'N/A'
            },

            archiveInterest: async function ( listing, archive ) {
                try {
                    const archive_rs = await axios.post(`${appUrls.api}/api/admin/buyer_listing_archive`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            buyer_id: listing.buyer_id,
                            listing_id: listing.lid,
                            listing_identifier: listing.listing_id,
                            project_id: this.project_details.project_id,
                            is_archived: archive
                        }
                    })

                    this.triggerUserFeedback( true, archive_rs.data.message, archive_rs.data.outcome ? 'light-green' : 'accent' );
                    if ( archive_rs.data.outcome ) this.getListingsForBuyer(listing.buyer_id);
                } catch ( error ) {
                    console.log(error);
                    this.triggerUserFeedback( true, `Something went wrong trying to ${archive ? 'archive' : 'unarchive'} interest in listingID: ${listing.listing_id}`, 'accent' );
                }
            },

            toggleListingCard: function ( id ) {
                this.$set(this.expandedListings, id, !this.expandedListings[id])
            },

            openStatusDrawer: function ( listing, statusId ) {
                const buyerData = this.user_data[0]

                this.statusDrawerListing = listing
                this.statusDrawerStatusId = statusId
                this.statusDrawerBuyers = [{
                    buyer_id: listing.buyer_id,
                    email: buyerData.user_email,
                    buyer_fullname: buyerData.first_name+' '+buyerData.last_name,
                    project_id: this.project_details.project_id
                }]
                this.statusDrawer = true
            },

            statusUpdated: function ( message ) {
                this.triggerUserFeedback( true, message );

                this.listings_refresh = true;
                setTimeout(() => {
                    this.getListingsForBuyer(this.statusDrawerListing.buyer_id);
                    this.listings_refresh = false;
                }, 1000)
            },

            expressInterest: async function ( uid ) {
                this.expressData = { uid, available_buyer_listings: this.available_buyer_listings }
                this.addBuyerToListings(this.expressData);
                this.available_buyer_listings=[];
            },

            addBuyerToListings: async function ( expressData ) {
                const userId = expressData.uid
                const avBuyerListings = expressData.available_buyer_listings

                const express_buyer_rs = await axios.post(`${appUrls.api}/api/admin/express_buyer`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    buyer_id: userId,
                    listing_ids: avBuyerListings
                })

                if ( express_buyer_rs.data.outcome ) {
                    this.getListingsForBuyer(userId);
                    // let text_ending = this.current_listings.length == 1 ? '.':'s.'
                    // let message_text = `${this.users[0].first_name} ${this.users[0].last_name} is currently on the buyers list for ${this.current_listings.length} listing${text_ending}`
                }
                
                this.triggerUserFeedback( true, express_buyer_rs.data.message );
            },

            exportAnswers: async function ( project_details ) {
                try {
                    const export_prj_data_rs = await axios.post(`${appUrls.api}/api/admin/export_data`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        moduleKey: project_details.modinfo.module_key,
                        projectId: project_details.project_id,
                        userId: project_details.user_id,
                        parentProjectId: project_details.parent_project_id
                    })

                    if ( export_prj_data_rs.data.outcome ){
                        this.$feedback.success( export_prj_data_rs.data.message );

                        const this_fileData = new Buffer(export_prj_data_rs.data.buf, 'base64');
                        const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const this_fileName = export_prj_data_rs.data.basic_data.file_name+'.'+export_prj_data_rs.data.basic_data.output_type;
                        
                        const this_blob = new Blob([this_fileData], {type: this_fileType});
                        saveAs(this_blob, this_fileName);

                    } else {
                        this.$feedback.error( 'There was a problem during the process of exporting the answers for this project.' );
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDocs: async function ( project_details ) {
                try {
                    this.refresh_docs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/false`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        project_details.docs = pulled_files.data.files.filter( file => file.is_revision == false);
                        project_details.revs = pulled_files.data.files.filter( file => file.is_revision == true);
                        this.refresh_docs = false
                        this.refreshProject(project_details)
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDelivs: async function ( project_details ) {
                try {
                    this.refresh_delivs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/true`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    project_details.dlvs = pulled_files.data.files;
                    this.refresh_delivs = false
                    this.refreshProject(project_details)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            toggleVisiblity: async function ( project_data, type ) {
                try {

                    const resource_vis = await axios.post(`${appUrls.api}/api/admin/update_resource_visibility/${type}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project_data
                    })

                    if ( resource_vis.data.outcome ) this.project_details.resource_visibility = resource_vis.data.project.resource_visibility
                    this.triggerUserFeedback( true, resource_vis.data.message )

                } catch ( error ) {
                    console.log(error)
                }
            },

            playResourceVideo: async function ( data ) {
                this.videoDialog = true
                this.videoUrl   = data.url
                // https://mycompass-production.s3.us-west-2.amazonaws.com/resource_files/Introduction%20Video.mp4?
                // X-Amz-Algorithm=AWS4-HMAC-SHA256&
                // X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&
                // X-Amz-Credential=AKIAXMOUSJ6P5QSDNUMA%2F20250723%2Fus-west-2%2Fs3%2Faws4_request&
                // X-Amz-Date=20250723T164445Z&
                // X-Amz-Expires=259200&
                // X-Amz-Signature=9939f9345861ac75ba6d5d847b9b8f75a0d14bf61ff5d9b03c05de4b9ff4e545&
                // X-Amz-SignedHeaders=host&
                // x-amz-checksum-mode=ENABLED&
                // x-id=GetObject
                this.videoValid = await this.videoValidation( this.videoUrl )

                if ( this.videoValid ) {
                    this.videoId     = data.fileid
                    this.videoSrc    = data.url.includes('vimeo') ? 'Vimeo' : 'AWS'
                    this.videoTitle  = data.title
                    this.videoType   = data.type
                }
            },

            videoValidation: async function ( videoUrl ) {
                try {
                    if ( videoUrl.includes('vimeo') ) return true

                    const video_params = new URLSearchParams(videoUrl.split('?')[1]);
                    const signature = video_params.get('X-Amz-Signature') || video_params.get('Signature') || false // S3 OR CLOUDFRONT SIGNED URL
                    const expires = video_params.get('X-Amz-Expires') || video_params.get('Expires') || false
                    const today = Date.now()

                    return signature != false && expires != false && today >= expires
                } catch (error) {
                    // console.log('error', error.response)
                    return false
                }
            },

            closeVideo () {
                this.videoDialog = null
                this.videoValid  = null
                this.videoId     = ''
                this.videoSrc    = ''
                this.videoUrl    = ''
                this.videoType   = ''
                this.videoTitle  = 'Resource Video'
            },

            refreshUsers: async function ( projectId, message_override='' ) {
                try {
                    const project_users = await axios.get(`${appUrls.api}/api/project_users/${projectId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                
                    this.project_details.users = project_users.data.users

                    const feedback_msg = message_override != '' ? message_override : project_users.data.message
                    this.triggerUserFeedback( true, feedback_msg);
                    // this.pullActivityLogs(this.project_details)
                
                } catch ( error ) {
                    console.log(error);
                    this.triggerUserFeedback( true, error, 'accent' );
                }
            },

            handleCopyEmail: function () {
                navigator.clipboard.writeText(document.querySelector('div#copy-email').innerText.trim())
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 3000);
            },

            // questionnaireLocking: async function ( project ) {
            //     try {
            //         const questionnaire_lock_rs = await axios.put(`${appUrls.api}/api/admin/project_questionnairelock`, {
            //             headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
            //                 project,
            //                 lock: !project.questionnaire_locked
            //         })

            //         if( questionnaire_lock_rs.data ) {
            //             this.triggerUserFeedback( true, questionnaire_lock_rs.data.message );
            //             this.projectDetails( project.user_id, project.project_id );
            //         }

            //     } catch ( error ) {
            //         console.log(error);
            //     }
            // },
            
            // initDisableProject: async function ( prj ) {
            //     this.disableDialog = true
            //     const archive_action = prj.is_archived ? 'unarchive' : ''
            //     const project_status = prj.status

            //     this.disableArgs = { 
            //         remove_project_id: prj.project_id, 
            //         remove_module_name: prj.modinfo.module_name, 
            //         archive_action: archive_action,
            //         project_status: project_status
            //     }
            // },

            // closeDisableDialog: function ( archiveWork ) {
            //     this.archiveWork = archiveWork
            //     this.disableDialog = false
            // },

            // createListing: async function (project_id) {
            //     axios.post(`${appUrls.api}/api/admin/create_listing`, {
            //         headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
            //         project_id: project_id,
            //         new_listing_state: this.new_listing_state,
            //         lists: this.arrLists
            //     })
            //     .then( res => {
            //         this.listingDialog = false;
                    
            //         if(res.data.outcome) {
            //             this.newlisting_text = 'Listing Exists';
            //             this.newlisting_disabled = true;

            //             this.notify_user = true;
            //             this.notify_user_message = res.data.message;
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            // },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC !important;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .header_bg_color {
        font-size: 1.15em !important;
        background-color: var(--v-primary-darken1)
    }
    .header_text_small {
        font-size: .9em !important;
    }
    .header_text_big {
        font-size: 1.1em !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 3rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .refresh_response {
        font-size: .8rem;
    }
    .click_indicator {
		width: 50px; 
		height: 3px; 
		border-top: 1px dotted rgba(0,0,0,.3);
		border-bottom: 1px dotted rgba(0,0,0,.3);
	}
    .listing-card-toggle {
        cursor: pointer;
    }
    .listing-id-link {
        cursor: pointer;
    }
    .notes-dot {
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background-color: #E53935;
        box-shadow: 0 0 0 1px rgba(255, 255, 255, .8);
    }
    .user_link {
        text-decoration: none;
    }
    .user_link:hover {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/BuyerDetails.vue